import { targetSetupStore } from "../stores/target-setup.store";
import { targetSetupUIStore } from "../stores/target-setup-ui.store";

export const useTargetSetupStore = () => targetSetupStore;
export const useTargetSetupUIStore = () => targetSetupUIStore;
